import React, { useContext, useState } from 'react';
import api from '../../services/api';
import {toast} from 'react-toastify'
import Layout from './layout';
import AppContext from '../../redux/contexts/appContext';

function Config() {
  const {state, dispatch} = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [changePwdMessage, setchangePwdMessage] = useState(null);
  const [loadingResetPwd, setloadingResetPwd] = useState(false);


  const onSave = (json) => {
    setLoading(true);
       
    api().put('/user', json)
    .then(response => {
      toast.success(response.data.msg)
      dispatch({type: 'set-user', payload: {...state.user, ...json}});
      setLoading(false);
    })
    .catch(err => {
      toast.success(err.response.data.msg)
      setLoading(false);
    })
  }

  const onChangePassword = () => {
    setloadingResetPwd(true);
    api().post('/user/password/forgot', {email: state.user.email})
    .then(response => {
      setloadingResetPwd(false);
      setchangePwdMessage("Due security reasons, an email was sent to you so you can reset your password");
    })
    .catch(err => {
      setloadingResetPwd(false);
      setchangePwdMessage(err.result.data.msg);
    })
  }

  const onImgChange = async (e) => {
    return new Promise(async (resolve, reject) => {
      setLoading(true);
      var body = {
        char: e
      }
      
      await api().post(`/user/${state.user.id}/change-char`, body)
      .then(response => {
        toast.success(response.data.msg)
        dispatch({type: 'set-user', payload: {...state.user, char: response.data.char}});
        setLoading(false);
        return resolve();
      })
      .catch(err => {
        toast.error(err.response.data.msg)
        setLoading(false);
        return reject();
      })
    })
  }

  return <Layout loading={loading} onImgChange={onImgChange} onSave={onSave} user={state?.user} onChangePassword={onChangePassword} loadingResetPwd={loadingResetPwd} changePwdMessage={changePwdMessage} onChangePwdMessageSubmit={() => setchangePwdMessage(null)}></Layout>;
}

export default Config;